export const DEFAULT_THEME_TERTIARY_COLOR = '#f5f5f5';
export const DEFAULT_THEME_PRIMARY_COLOR = '#670fc4';
